import { Reveal } from "@/components/Reveal";

const FOUNDER_PORTRAIT = "/founder-portrait.png";

const About = () => (
    <section
        id="about"
        data-testid="about-section"
        className="relative overflow-hidden px-6 py-32 sm:py-40 lg:px-16 lg:py-52"
    >
        <div className="mx-auto max-w-6xl">
            <div className="grid grid-cols-1 gap-16 md:grid-cols-2 lg:gap-20">
            <Reveal>
                <p className="mb-8 font-display text-[10px] uppercase tracking-[0.5em] text-[#270057]">
                    About Us
                </p>
                <h2
                    data-testid="about-title"
                    className="text-left font-serif text-[2rem] font-normal leading-[1.12] tracking-[-0.01em] text-[#270057] sm:text-4xl lg:text-[2.8rem]"
                >
                    <span className="block">The Architecture of</span>
                    <span className="block whitespace-nowrap">
                        <em className="italic">Cinematic</em> Post‑Production
                    </span>
                </h2>
                <div className="royal-rule mt-12 w-24" />
            </Reveal>

                <Reveal delay={0.1}>
                    <p
                        data-testid="about-paragraph-1"
                        className="text-base font-normal leading-relaxed text-[#270057] sm:text-lg"
                    >
                        Vellor Studio is a specialized offline video editing and
                        post-production facility built on a foundation of
                        absolute precision and operational discipline. We do not
                        merely assemble footage; we architect narratives.
                        Operating at the intersection of creative storytelling
                        and rigorous technical structure, we serve as a
                        grounded, reliable partner for commercial campaigns,
                        brand films, and complex digital assets.
                    </p>
                </Reveal>
            </div>

            <Reveal delay={0.1}>
                <div
                    data-testid="about-block-leadership"
                    className="mt-24 grid grid-cols-1 gap-12 border-t border-[#270057]/15 pt-16 md:grid-cols-12 lg:gap-16"
                >
                    <div className="md:col-span-4">
                        <div className="border border-[#270057]/20 p-3">
                            <img
                                src={FOUNDER_PORTRAIT}
                                alt="Swapnil Gawand, Founder and Creative Director of Vellor Studio"
                                data-testid="founder-portrait"
                                loading="lazy"
                                className="aspect-[4/5] w-full object-cover object-top"
                            />
                        </div>
                        <div data-testid="founder-caption" className="mt-5 text-center">
                            <p className="font-display text-xs font-semibold uppercase tracking-[0.3em] text-[#270057]">
                                Swapnil Gawand
                            </p>
                            <p className="mt-2 font-sans text-[10px] font-normal uppercase tracking-[0.25em] text-[#270057]">
                                Founder & Creative Director
                            </p>
                        </div>
                    </div>
                    <div className="md:col-span-8 md:self-center">
                        <h3 className="font-serif text-2xl font-medium text-[#270057] lg:text-3xl">
                            Leadership & Industry Pedigree
                        </h3>
                        <p className="mt-6 text-base font-normal leading-relaxed text-[#270057] sm:text-lg">
                            Vellor Studio was established by Founder and
                            Creative Director Swapnil Gawand. Backed by 15 years
                            of entrenched experience across the video production
                            and editing industry, the studio was built to solve
                            a critical gap in the production pipeline: the
                            demand for disciplined, timeline-driven offline
                            editing that fiercely protects the director's
                            original intent while adhering to strict commercial
                            schedules.
                        </p>
                    </div>
                </div>
            </Reveal>

            <Reveal delay={0.15}>
                <div
                    data-testid="about-block-ecosystem"
                    className="mt-16 grid grid-cols-1 gap-8 border-t border-[#270057]/15 pt-16 md:grid-cols-12"
                >
                    <h3 className="font-serif text-2xl font-medium text-[#270057] md:col-span-4 lg:text-3xl">
                        The Collaborative Ecosystem
                    </h3>
                    <p className="text-base font-normal leading-relaxed text-[#270057] md:col-span-8">
                        Our operational strength lies in our Partnership
                        Program. We have engineered Vellor Studio to function as
                        a collaborative hub, striking a precise balance between
                        highly qualified, seasoned industry freelancers and the
                        directors, agency creative leads, and production houses
                        we serve. We provide the robust technical infrastructure
                        that allows creative talent to execute flawlessly. For
                        production houses and agencies, this ecosystem means
                        gaining a steadfast post-production partner capable of
                        scaling seamlessly with your project's demands.
                    </p>
                </div>
            </Reveal>
        </div>
    </section>
);

export default About;
